document.addEventListener('DOMContentLoaded', function () {
  function attachAccordionListeners() {
    const dealAccordions = document.querySelectorAll('.deal-accordion-toggle');
    dealAccordions.forEach(dealAccordion => {
      if (!dealAccordion.hasAttribute('data-listener-attached')) {
        console.log('Attaching click event to:', dealAccordion);
        dealAccordion.addEventListener('click', function (event) {
          event.stopPropagation();
          const uniqueId = this.id.split('-').pop();
          const content = document.getElementById(`deal-accordion-content-${uniqueId}`);
          const expanded = this.getAttribute('aria-expanded') === 'true' || false;
          this.setAttribute('aria-expanded', !expanded);
          content.hidden = expanded;
          console.log(`Toggled accordion ${uniqueId}:`, !expanded);
        });
        dealAccordion.setAttribute('data-listener-attached', 'true');
      }
    });

    const dealAccordionCloses = document.querySelectorAll('.deal-accordion-close');
    dealAccordionCloses.forEach(dealAccordionClose => {
      if (!dealAccordionClose.hasAttribute('data-listener-attached')) {
        console.log('Attaching close event to:', dealAccordionClose);
        dealAccordionClose.addEventListener('click', function (event) {
          event.stopPropagation();
          const uniqueId = this.id.split('-').pop();
          const content = document.getElementById(`deal-accordion-content-${uniqueId}`);
          const toggleButton = document.getElementById(`deal-accordion-toggle-${uniqueId}`);
          toggleButton.setAttribute('aria-expanded', false);
          content.hidden = true;
          console.log(`Closed accordion ${uniqueId}`);
        });
        dealAccordionClose.setAttribute('data-listener-attached', 'true');
      }
    });
  }

  attachAccordionListeners();

  const observer = new MutationObserver(attachAccordionListeners);
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function () {
    const dealAccordions = document.querySelectorAll('.deal-accordion-toggle');
    dealAccordions.forEach(dealAccordion => {
      const uniqueId = dealAccordion.id.split('-').pop();
      const content = document.getElementById(`deal-accordion-content-${uniqueId}`);
      dealAccordion.setAttribute('aria-expanded', false);
      content.hidden = true;
      console.log(`Closed all accordions`);
    });
  });

  const dealSections = document.querySelectorAll('.deal-section');

  function updateDealAccordionState() {
    const productGridOuter = document.querySelector('.productgrid--outer');
    const isGridView = productGridOuter ? productGridOuter.classList.contains('productgrid-gridview') : true;

    dealSections.forEach(section => {
      const dealAccordion = section.querySelector('.deal-accordion');
      const dealDetails = section.querySelector('.deal-details');
      if (isGridView) {
        dealAccordion.style.display = 'block';
        dealDetails.style.display = 'none';
        console.log('Grid view: Showing accordions');
      } else {
        dealAccordion.style.display = 'none';
        dealDetails.style.display = 'block';
        console.log('List view: Showing details');
      }
    });
  }

  updateDealAccordionState();

  const productGridOuter = document.querySelector('.productgrid--outer');
  if (productGridOuter) {
    const observer = new MutationObserver(updateDealAccordionState);
    observer.observe(productGridOuter, { attributes: true, attributeFilter: ['class'] });
    console.log('Observer attached to product grid outer');
  }

  const viewToggleButtons = document.querySelectorAll('[data-collection-view]');
  viewToggleButtons.forEach(button => {
    button.addEventListener('click', function () {
      setTimeout(updateDealAccordionState, 100); // Delay to allow class change
      console.log('View toggle button clicked');
    });
  });
});

